module.exports = __webpack_public_path__ + "img/emt_madrid_hero_bg.8710a8f7.png";